import { LoggedInWrapper } from "layout/LoggedInWrapper/LoggedInWrapper";
import { LoggedOutWrapper } from "layout/LoggedOutWrapper/LoggedOutWrapper";
import Meta from "layout/Meta/Meta";
import BackgroundTasksIndicator from "newComponents/Shared/BackgroundTasksIndicator/BackgroundTasksIndicator";
import Toast from "newComponents/Shared/_Atoms/Toast/Toast";
import WhatsNewModal from "newComponents/Shared/WhatNew/WhatsNewModal/WhatsNewModal";
import Router from "next/router";
import React, { FC, ReactElement, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeSelectActiveLocation } from "Store/locations/selectors";
import { getCurrentUser, handleUpdateLastVersionSeen, setUserIsLogged } from "Store/user/actions";
import { loggedIn } from "Store/user/AuthService";
import {
  makeSelectAuthorizedStatus,
  makeSelectCurrentUser,
  makeSelectUserIsLogged
} from "Store/user/selectors";
import HeaderProvider from "utils/context/HeaderContext";
import config from "../../package.json";
import NEWS from "constants/localization/news";
import { getSlidesToDisplay } from "utils/newsHelpers";
import Login from "pages/login";
import { fetchCurrentLocation } from "Store/locations/actions";
import GlobalSpinner from "newComponents/Shared/_Atoms/Spinner/GlobalSpinner/GlobalSpinner";
import Script from "next/script";
import {ScoreReportWrapper} from "../ScoreReportWrapper/ScoreReportWrapper";

interface IProps {
  children: ReactElement;
}

const Page: FC<IProps> = ({ children }) => {
  const [impersonateAvatar, setImpersonateAvatar] = useState(null);
  const [showNewsModal, setShowNewsModal] = useState<boolean>(false);
  const [enableFetchCurrentUser, setEnableFetchCurrentUser] = useState<boolean>(true);
  const router = Router;
  const dispatch = useDispatch();
  const activeUser = useSelector(makeSelectCurrentUser);
  const authorizedStatus = useSelector(makeSelectAuthorizedStatus);
  const currentLocation = useSelector(makeSelectActiveLocation);
  const isUserLogged = useSelector(makeSelectUserIsLogged);
  const [isScoreReport, setScoreReport] = useState<boolean>(false);

  const calculateVersionsDifference = (): boolean => {
    const user = activeUser;

    if (!user?.last_version_seen) return true;

    const lastVersionSaw = user?.last_version_seen.split(".").map((n) => parseInt(n, 10));

    const appVersion = config.version.split(".").map((n) => parseInt(n, 10));

    if (appVersion[0] > lastVersionSaw[0]) {
      return true;
    } else if (appVersion[0] === lastVersionSaw[0]) {
      if (appVersion[1] > lastVersionSaw[1]) {
        return true;
      } else {
        if (appVersion[2] > lastVersionSaw[2]) {
          return true;
        }
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    const pattern = /generate-report/i;
    const subject = window.location.href;

    const matches = subject.match(pattern);

    if (matches) {
      setScoreReport(true);
    }
    console.log(window.location.href);
    dispatch(fetchCurrentLocation());
  }, []);

  const handleCloseNewsModal = (): void => {
    const payload = {
      instructor_id: activeUser.id,
      last_version_seen: config.version
    };
    dispatch(handleUpdateLastVersionSeen(payload));
    setShowNewsModal(false);
  };

  useEffect(() => {
    if (router.route === "/reset") return null;
    if (router.route === "/generate-report") return null;

    dispatch(getCurrentUser());
    if (!loggedIn() || !authorizedStatus) {
      dispatch(setUserIsLogged(false));
      router.push("/login");
    } else {
      dispatch(setUserIsLogged(loggedIn()));
    }
  }, []);

  useEffect(() => {
    const avatar = typeof window !== "undefined" ? localStorage.getItem("impersonated") : null;
    setImpersonateAvatar(avatar);
  }, []);

  useEffect(() => {
    if (router.route === "/reset") return null;
    if (router.route === "/generate-report") return null;
    if (
      (!authorizedStatus && enableFetchCurrentUser) ||
      (enableFetchCurrentUser && activeUser?.type === "STUDENT")
    ) {
      setEnableFetchCurrentUser(false);
      Router.push("/login");
    }
  }, []);

  useEffect(() => {
    if (activeUser && !activeUser.last_version_seen && NEWS.length > 0) {
      return setShowNewsModal(true);
    }
    if (
      calculateVersionsDifference() &&
      activeUser &&
      currentLocation &&
      !impersonateAvatar &&
      getSlidesToDisplay(activeUser?.last_version_seen).length > 0
    ) {
      setShowNewsModal(true);
    }
  }, [activeUser, currentLocation]);

  return currentLocation ? (
    <>
      <Meta title={currentLocation?.name || "Clear Choice Test Prep"} />
      <Script>
        {`
                (function(apiKey){
                    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
                    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
                        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
                        y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
                        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
                })('5543faec-5766-47ee-6dd0-585d21f398cc');
            `}
      </Script>
      {showNewsModal && !impersonateAvatar && <WhatsNewModal onClose={handleCloseNewsModal} />}

      <>
        {isUserLogged ? (
          <HeaderProvider>
            <LoggedInWrapper>{children}</LoggedInWrapper>
          </HeaderProvider>
        ) : (
            isScoreReport ? (
                <ScoreReportWrapper location={currentLocation}>
                  {children}
                </ScoreReportWrapper>
            ) :
          <LoggedOutWrapper location={currentLocation}>
            <Login />
          </LoggedOutWrapper>
        )}
      </>
      <Toast />
      {isUserLogged && <BackgroundTasksIndicator />}
    </>
  ) : (
    <GlobalSpinner fetchingText=" " key="" />
  );
};

export default Page;
